import { css, cx } from '@capturi/ui-components/styled-system/css'
import { splitCssProps } from '@capturi/ui-components/styled-system/jsx'
import type { HTMLStyledProps } from '@capturi/ui-components/styled-system/types'
import type { ComponentPropsWithRef, ElementType } from 'react'

export type BoxProps<T extends ElementType = 'div'> = HTMLStyledProps<T> &
  Omit<ComponentPropsWithRef<T>, keyof HTMLStyledProps<T>> & {
    as?: T
  }

export function Box<T extends ElementType = 'div'>(rawProps: BoxProps<T>) {
  const { as, className, ref, ...rest } = rawProps

  // Split: style props vs DOM props
  const [cssProps, otherProps] = splitCssProps(rest)

  // Compose classes from style props + optional `css` object containing selectors.
  // Panda was previously just receiving a property called css, which it cannot read.
  // Panda needs a css styles object at top level. so merging is the way to go

  // Fixed by pulling it out as such, and passing it as an extra style object.
  const { css: cssProp = {}, ...styleProps } = cssProps
  const cls = css(styleProps, cssProp)

  const Comp: ElementType = as ?? 'div'
  return <Comp ref={ref} {...otherProps} className={cx(cls, className)} />
}
